import { Fragment, useMemo, useState } from 'react';
import { Button } from '../../../../../core/components/atoms/Button';
import { Icon } from '../../../../../core/components/atoms/Icon';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { getDisciplineName } from '../../../../../core/utils/discipline';
import { IPAContent } from '../../../model/dailySchedule';
import { useDailyScheduleContentStore } from '../../../stores/useDailyScheduleContent';
import { orderBySubareaAndAddTitleSection } from '../../../utils/DaySchedule';
import PlaylistModal from '../Playlist';

const FooterMenu = () => {
  const [isContentModalOpen, setIsContentModalOpen] = useState(false);
  const {
    selectedDiscipline,
    selectedWeek,
    contentList,
    setSelectedContent,
    selectedContent,
    contentListFilter,
  } = useDailyScheduleContentStore((s) => ({
    selectedDiscipline: s.selectedDiscipline,
    selectedWeek: s.selectedWeek,
    contentList: s.contentList,
    setSelectedContent: s.setSelectedContent,
    selectedContent: s.selectedContent,
    contentListFilter: s.contentListFilter,
  }));

  const filteredContentList = useMemo(() => {
    if (contentListFilter === 'all') {
      return orderBySubareaAndAddTitleSection(contentList, false);
    }

    const newList = contentList.filter(
      (item) => item.type === contentListFilter
    );

    return orderBySubareaAndAddTitleSection(newList, false);
  }, [contentList, contentListFilter]) as IPAContent[];

  const selectedContentIndex = useMemo(() => {
    return filteredContentList.findIndex(
      (item) => item.content.id === selectedContent?.content.id
    );
  }, [filteredContentList, selectedContent]);

  function handleNextContent() {
    const nextContent = filteredContentList[selectedContentIndex + 1];

    if (nextContent) {
      setSelectedContent(nextContent);
    }
  }

  function handlePrevContent() {
    const prevContent = filteredContentList[selectedContentIndex - 1];

    if (prevContent) {
      setSelectedContent(prevContent);
    }
  }

  return (
    <Fragment>
      <div className='flex bg-color-lightest flex-row items-center justify-between px-4 py-3 shadow-level-1 lg:hidden'>
        <Button
          variant='outlined'
          className='text-mono-color-black'
          onClick={() => handlePrevContent()}
          disabled={!selectedContent || selectedContentIndex === 0}
        >
          <span className='hidden text-mono-color-black md:block'>
            Conteúdo Anterior
          </span>
          <span className='text-sm text-mono-color-black md:hidden'>
            <Icon Icon='chevron_left' type='material' />
          </span>
        </Button>
        {selectedDiscipline && (
          <Button
            variant='text'
            onClick={() => setIsContentModalOpen(!isContentModalOpen)}
          >
            <div className='flex flex-row items-center gap-sm'>
              <Icon Icon='list' type='material' className='hidden md:block' />
              <Typography className='text-brand-color-primary-default'>
                Playlist de {getDisciplineName(selectedDiscipline)}
              </Typography>
            </div>
          </Button>
        )}
        <Button
          variant='outlined'
          className='text-mono-color-black'
          onClick={() => handleNextContent()}
          disabled={
            !selectedContent || selectedContentIndex === contentList.length - 1
          }
        >
          <span className='hidden text-mono-color-black md:block'>
            Próximo Conteúdo
          </span>
          <span className='text-sm text-mono-color-black md:hidden'>
            <Icon Icon='chevron_right' type='material' />
          </span>
        </Button>
      </div>
      <PlaylistModal
        isOpen={isContentModalOpen}
        onClose={() => setIsContentModalOpen(false)}
        title={`Playlist de ${getDisciplineName(selectedDiscipline)}`}
        subtitle={`Semana ${selectedWeek}`}
      />
    </Fragment>
  );
};

export default FooterMenu;
